// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1SXv3","content":"GlobalSearch_content__12O7H"};